import Vue from "vue";
import Vuex from "vuex";
import scrollToElement from 'scroll-to-element';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        isProgramScrollingNow: 0,
        expandFinanceBlock: null,
        isMenuOpened: false,
    },
    getters: {
        expandFinanceBlockGet (state) {
            return state.expandFinanceBlock;
        }
    },
    mutations: {
        changeProgramScrollingNow(state, payload) {
            state.isProgramScrollingNow += payload;
        },
        expandFinanceBlockMutator(state, payload) {
            state.expandFinanceBlock = payload;
        },
        isMenuOpenedChange(state, payload) {
            state.isMenuOpened = payload;
        },
    },
    actions: {
        scrollToElement(context, payload) {
            const element = payload.element;
            const duration = payload.duration;
            const payloadOffset = payload.hasOwnProperty('offset') ? payload.offset : null;
            const payloadDelay = payload.hasOwnProperty('delay') ? payload.delay : 0;
            const header = document.querySelector('.header');
            let offset = 64;
            if (payloadOffset !== null) {
                offset = payloadOffset;
            } else if (header) {
                offset = header.offsetHeight - 1;
            }
            if (element) {
                this.commit('changeProgramScrollingNow', +1);
                setTimeout(() => {
                    scrollToElement(element,{
                        duration: duration,
                        ease: 'outQuad',
                        offset: -offset,
                    }).on('end', () => {
                        this.commit('changeProgramScrollingNow', -1);
                    })
                }, payloadDelay);

                // let self = this;
                // const startingY = window.pageYOffset;
                // const diff = startingY - element.offsetTop  + 1;
                // let start;
                //
                // let rect = element.getBoundingClientRect();
                // let offsetTop = rect.top + document.body.scrollTop;
                //
                // // Bootstrap our animation - it will get called right before next frame shall be rendered.
                // window.requestAnimationFrame(function step(timestamp) {
                //     if (!start) start = timestamp;
                //     // Elapsed milliseconds since start of scrolling.
                //     const time = timestamp - start;
                //     // Get percent of completion in range [0, 1].
                //     const percent = Math.min(time / duration, 1);
                //
                //     window.scrollTo(0, startingY + diff * percent);
                //
                //     // Proceed with animation as long as we wanted it to.
                //     if (time < duration) {
                //         window.requestAnimationFrame(step);
                //     } else {
                //         self.commit('changeProgramScrollingNow', -1);
                //     }
                // });
            }
        },
        expandFinanceBlockAction(context, payload) {
            this.commit('expandFinanceBlockMutator', payload);
        },
        menuOpen(context, payload) {
            this.commit('isMenuOpenedChange', payload);
        }
    }
});